/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface WebhookControllerHandleStripeWebhook$Params {
  'stripe-signature': string;
}

export function webhookControllerHandleStripeWebhook(http: HttpClient, rootUrl: string, params: WebhookControllerHandleStripeWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, webhookControllerHandleStripeWebhook.PATH, 'post');
  if (params) {
    rb.header('stripe-signature', params['stripe-signature'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

webhookControllerHandleStripeWebhook.PATH = '/keus-payments/webhook/stripe';
